import {FC} from 'react';
import {styled} from 'styled-components';

import {ParsedDb} from '@src/lib/db_store';

interface NameSpellingsProps {
  dbName: ParsedDb[0];
  color: string;
}

export const NameSpellings: FC<NameSpellingsProps> = ({dbName, color}) => {
  return (
    <Table>
      <tbody>
        {dbName.totalByName.map(({name, count}) => {
          const ratio = count / dbName.total;
          const ratioPercent = `${Math.round(ratio * 100)}%`;
          return (
            <tr key={name}>
              <Cell>{name}</Cell>
              <Cell>
                {
                  <RatioContainer>
                    <RatioBar $color={color} style={{width: ratioPercent}} />
                  </RatioContainer>
                }
              </Cell>
              <Cell $right>{ratioPercent}</Cell>
              <Cell $right>{count.toLocaleString()}</Cell>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

NameSpellings.displayName = 'NameSpellings';

const Table = styled.table`
  width: fit-content;
`;

const Cell = styled.td<{$right?: boolean}>`
  text-align: ${({$right}) => ($right ? 'right' : 'left')};
  padding: 0 0.15rem;
  font-size: 0.9rem;
  vertical-align: middle;
`;

const RatioContainer = styled.div`
  width: 10rem;
  height: 0.5rem;
  background-color: #00000022;
  border-radius: 1000rem;
`;

const RatioBar = styled.div<{$color: string}>`
  height: 100%;
  background-color: ${({$color}) => $color};
  border-radius: 1000rem;
`;
